import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    loading: false,
    title: 'tsingtao',
    permissionItem: [],
    // typeId: 9001,
    typeId: window.location.port,
    userInfo: {
      userId: '',
      userName: '',
    },
  },
  getters: {
    //时间戳转日期
    unixTime: (state) => (t) => {
      const reg = /[\u4e00-\u9fa5]/g;
      const time = new Date(parseInt(t) * 1000).toLocaleString();
      return time.replace(reg, ' ').replace(/:\d{1,2}$/, ' ');
    },
  },
  actions: {
    setUserInfo(context, userInfo) {
      Object.freeze(userInfo)
      context.commit('setUserInfo', userInfo)
    },
    setTitle(context, title) {
      context.commit('setTitle', title)
    },
    setTypeId(context, typeId) {
      context.commit('setTypeId', typeId)
    },
    setPermissionItem(context, permissionItem) {
      Object.freeze(permissionItem)
      context.commit('permissionItem', permissionItem)
    },
    logout(context) {
      var userInfo = context.state.userInfo
      if (userInfo) {
        context.dispatch('clearUserInfo')
      }
    },
  },
  modules: {},
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setTitle(state, title) {
      state.title = title
    },
    setTypeId(state, typeId) {
      state.typeId = typeId
    },
    setPermissionItem(state, permissionItem) {
      state.permissionItem = permissionItem
    }
  }
})

//权限判断 全局指令
Vue.directive('permission', {
  bind: function (el, val) {
    if (store.state.permissionItem) {
      const index = store.state.permissionItem.findIndex(res => res.name == val.value)
      index < 0 && (el.style.display = 'none')
    }
  }
})

export default store
